function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import Cookies from 'js-cookie';

var CountrySelector = /*#__PURE__*/function () {
  function CountrySelector() {
    _classCallCheck(this, CountrySelector);
  }

  _createClass(CountrySelector, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-country-selector', {
        template: "\n      <div v-if=\"continents\" class=\"country-selector\">\n        <div class=\"grid-x\">\n          <div class=\"cell medium-10\">\n            <roche-input v-model=\"searchTerm\" @input=\"filterCountries\" :label=\"labels.inputLabel\" clearable></roche-input>\n          </div>\n        </div>\n        <h3 v-if=\"searchTerm && searchTerm.length > 0\" class=\"results\">{{labels.resultsHeadline}} <span class=\"counter\">{{results}}</span></h3>\n        <div v-for=\"continent in filteredData\" v-if=\"continent.countries && continent.countries.length > 0\" class=\"country-list\">\n          <h4>{{continent.name}}</h4>\n          <hr>\n          <ul v-if=\"continent.countries && continent.countries.length > 0\">\n            <li v-for=\"country in continent.countries\">\n              <a :href=\"country.link\" @click=\"preselectCountry(continent.preselect, country.code)\"><i :class=\"'flag-icon flag-icon-'+country.code+' flag-icon-round'\"></i> <span>{{country.name}}</span></a>\n            </li>\n          </ul>\n        </div>\n        <p v-if=\"searchTerm && searchTerm.length > 0 && results === 0\" class=\"no-results\">{{labels.noResultsText}}</p>\n      </div>",
        props: ['labels', 'continents'],
        data: function data() {
          return {
            filteredData: this.continents,
            searchTerm: '',
            results: 0
          };
        },
        methods: {
          filterCountries: function filterCountries() {
            var _this = this;

            if (!this.searchTerm || this.searchTerm.length === 0) {
              this.filteredData = this.continents;
              return;
            }

            this.results = 0;
            this.filteredData = this.continents.map(function (continent) {
              return _objectSpread(_objectSpread({}, continent), {}, {
                countries: continent.countries.filter(function (country) {
                  if (country.name.toLowerCase().includes(_this.searchTerm.toLowerCase())) {
                    _this.results++;
                    return true;
                  }

                  return false;
                })
              });
            });
          },
          preselectCountry: function preselectCountry(_preselectCountry, country) {
            if (_preselectCountry) {
              Cookies.set('preselectCountry', country.toUpperCase(), {
                expires: 1
              });
            } else {
              Cookies.remove('preselectCountry');
            }

            return true;
          }
        }
      });
    }
  }]);

  return CountrySelector;
}();

export default CountrySelector;